import { createContext, useContext, type ReactNode } from 'react';
import type {
	KycPlacementDraft,
	KycPlacementDraftSink,
	KycPlacementValue,
} from './kycSignaturePlacement.types.ts';

/**
 * The unsaved form's placement, both directions. The wizard lets a signature be placed before
 * the form is saved, and the adapter is a module-level constant that cannot close over drawer
 * state — so it reaches it through here.
 */
const KycPlacementDraftContext = createContext<KycPlacementDraftSink>({});

interface Props {
	children: ReactNode;
	onDraft: (draft: KycPlacementDraft) => void;
	pending?: KycPlacementValue | null;
}

export const KycPlacementDraftProvider = ({ children, onDraft, pending }: Props) => (
	<KycPlacementDraftContext.Provider value={{ onDraft, pending }}>
		{children}
	</KycPlacementDraftContext.Provider>
);

export const useKycPlacementDraftSink = (): KycPlacementDraftSink =>
	useContext(KycPlacementDraftContext);
